// ScheduleSummaryPopup.jsx
import { FaWindowClose, FaEdit, FaTrash } from 'react-icons/fa';
import { format } from 'date-fns';
import { getRecurrenceGroups } from './helpers'; // import your grouping logic
import './SchedulerSummaryPopup.css';

function ScheduleSummaryPopup({ events = [], onClose, onEdit, onDelete }) {
  // 1) Group events: One row per recurrence + single events
  //const { grouped, singleRecurrence } = getRecurrenceGroups(events);
  // const masterEvents = events.filter(e => e.isMaster === true);
  // const { grouped, singleRecurrence } = getRecurrenceGroups(masterEvents);

  const safeEvents = Array.isArray(events)
    ? events.filter(e => e.isMaster === true) // 🔥 ONLY MASTER EVENTS
    : [];

  const { grouped, singleRecurrence } = getRecurrenceGroups(safeEvents);


  // 2) Format functions
  const formatTimeRange = (evt) => {
    const start = new Date(evt.start);
    const end = new Date(evt.end);
    return `${format(start, 'p')} - ${format(end, 'p')}`;
  };

  const formatStartDate = (evt) => {
    return format(new Date(evt.start), 'PP p');
  };

  // ✅ FIXED: Correct End Date display logic
  const formatEndDate = (evt) => {
    if (evt.endType === 'Never' || !evt.endType) {
      return 'Never';
    } else if (evt.endType === 'on' && evt.endDateOn) {
      return format(new Date(evt.endDateOn), 'PP p');
    } else if (evt.endType === 'after' && evt.endAfter) {
      return `After ${evt.endAfter} occurrence${evt.endAfter > 1 ? 's' : ''}`;
    } else if (evt.lastOccurrence) {
      return format(new Date(evt.lastOccurrence), 'PP p');
    } else {
      return format(new Date(evt.end), 'PP p');
    }
  };

  // ✅ FIXED: Correct Summary display logic
  const formatSummary = (evt) => {
    if (evt.summary) {
      return evt.summary;
    }

    // If summary missing, build a fallback
    const startDate = new Date(evt.start);
    const startDay = startDate.toLocaleDateString(undefined, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

    if (evt.recurrenceId) {
      let recurrenceText = 'Recurring event';
      switch ((evt.recurrence || evt.recurrenceType || '').toLowerCase()) {
        case 'daily':
          recurrenceText = 'Occurs every day';
          break;
        case 'weekly':
          recurrenceText = 'Occurs every week';
          break;
        case 'bi-weekly':
          recurrenceText = 'Occurs every 2 weeks';
          break;
        case 'monthly':
          recurrenceText = 'Occurs every month';
          break;
        case 'yearly':
          recurrenceText = 'Occurs every year';
          break;
        case 'weekdays':
          recurrenceText = 'Occurs every weekday (Mon–Fri)';
          break;
        case 'weekends':
          recurrenceText = 'Occurs every weekend (Sat–Sun)';
          break;
        default:
          recurrenceText = 'Recurring event';
      }

      let endText = '';
      if (evt.endType === 'Never' || !evt.endType) {
        endText = 'and never ends';
      } else if (evt.endType === 'on' && evt.endDateOn) {
        const endStr = new Date(evt.endDateOn).toLocaleDateString(undefined, {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
        endText = `and ends on ${endStr}`;
      } else if (evt.endType === 'after' && evt.endAfter) {
        endText = `and ends after ${evt.endAfter} occurrence${evt.endAfter > 1 ? 's' : ''}`;
      }

      return `${recurrenceText} starting ${startDay} ${endText}`;
    }

    // Non-recurring
    return `Single-day event on ${startDay}`;
  };

  return (
    <div className="summary-popup-overlay">
      <div className="summary-popup-content">
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h2>All Unavailability / Events</h2>
          <button
            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            onClick={onClose}
          >
            <FaWindowClose size={20} />
          </button>
        </div>

        {/* Body */}
        {grouped.length === 0 && singleRecurrence.length === 0 ? (
          <p>No events found.</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={headerStyle}>Group</th>
                <th style={headerStyle}>Start Date</th>
                <th style={headerStyle}>End Date</th>
                <th style={headerStyle}>Time Closed</th>
                <th style={headerStyle}>Summary</th>
                <th style={headerStyle}>Edit</th>
                <th style={headerStyle}>Delete</th>
              </tr>
            </thead>
            <tbody>
              {[...grouped, ...singleRecurrence].map((evt) => (
                <tr key={evt.recurrenceId || evt.id}>
                  <td style={cellStyle}>{evt.groupName || "Default"}</td>
                  {/* Start Date */}
                  <td style={cellStyle}>{formatStartDate(evt)}</td>

                  {/* End Date */}
                  <td style={cellStyle}>{formatEndDate(evt)}</td>

                  {/* Time Closed (time-only range) */}
                  <td style={cellStyle}>{formatTimeRange(evt)}</td>

                  {/* ✅ Summary */}
                  <td style={cellStyle}>{formatSummary(evt)}</td>

                  {/* Edit button */}
                  <td style={cellStyle}>
                    <button
                      onClick={() => onEdit(evt)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                    >
                      <FaEdit />
                    </button>
                  </td>

                  {/* Delete button */}
                  <td style={cellStyle}>
                    <button
                      onClick={() => onDelete(evt)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

// Table styling
const headerStyle = {
  border: '1px solid #ccc',
  padding: '8px',
  background: '#f2f2f2',
};
const cellStyle = {
  border: '1px solid #ccc',
  padding: '8px',
};

export default ScheduleSummaryPopup;
